// export const iStaffBaseURL = "https://istaffapp.herokuapp.com";
export const iStaffBaseURL = "https://istaffapp-production.herokuapp.com";
export const iStaffLogoURL =
  "https://www.istaffaustralia.com.au//wp-content/uploads/2019/05/transparent-logo.png";
export const iStaffBusinessUrl = "https://www.istaffaustralia.com.au/";
export const iStaffContactNumber = "02 9525 8503";
export const iStaffContactEmail = "recruiting@istaffaustralia.com.au";
export const employeeShiftsBaseUrl = `https://api.datasavvy.com.au/searchme.asmx/GetEmployeeShifts?`;
